module.exports = __webpack_public_path__ + "img/badge-super-jet-air.2f03a151.svg";